import React from 'react'
import HMapTabData from './HMapTabData'
import HMapTabNoData from './HMapTabNoData'
import { makeStyles } from '@material-ui/core'
import { useHMapContext } from '../../hooks/useHMapContext'
import { getVisibleHeatmaps } from '../../utils/heatmapSelection'

const getTabName = (HMapTabs, currentTab) => {
  const searchRes = HMapTabs.filter((tab) => tab.code === currentTab)

  return searchRes.length ? searchRes[0].title : ''
}

const getCurrentTabData = (currentTab, allHeatMaps, sortSearch) => {
  /**
    if allHeatMaps does not exists | if allHeatMaps is not an array
    return an empty array []
   */
  if (!allHeatMaps) return []
  if (!Array.isArray(allHeatMaps)) return []

  // if allHeatMaps exists and its an array
  let data = []
  const { sortOrder, sortType, searchText } = sortSearch[currentTab]
  const visibleHeatmaps = getVisibleHeatmaps(allHeatMaps)

  // find current tab heatmaps
  data =
    currentTab === 'active'
      ? visibleHeatmaps.filter((item) => item.pin)
      : visibleHeatmaps.filter((item) => item.type === currentTab)

  // apply seearch criteria
  if (!!searchText) {
    data = data.filter((item) =>
      item.name.toLowerCase().includes(searchText.toLowerCase())
    )
  }

  // apply sorting criteria
  if (!!sortOrder && !!sortType) {
    data = data.sort((a,b) => {
      if (sortType === 'az' && sortOrder === 'asc') {
        return a.name.localeCompare(b.name)
      }

      if (sortType === 'az' && sortOrder === 'desc') {
        return b.name.localeCompare(a.name)
      }

      if (sortType === 'date' && sortOrder === 'asc') {
        return Date.parse(a.created_at) - Date.parse(b.created_at)
      }

      if (sortType === 'date' && sortOrder === 'desc') {
        return Date.parse(b.created_at) - Date.parse(a.created_at)
      }

      return a.name.localeCompare(b.name)
    })
  }
  
  return data
}

const HMapDisplayTabContent = ({
  HMapTabs,
  setCurrentPanel,
  currentTab,
  allHeatMaps,
  setAllHeatMaps
}) => {
  const classes = useStyles()
  const { sortSearchInfo } = useHMapContext()
  const [sortSearch,] = sortSearchInfo

  const currentTabData = [
    ...getCurrentTabData(currentTab, allHeatMaps, sortSearch)
  ]

  return (
    <div className={classes.root}>
      {currentTabData && currentTabData.length ? (
        <HMapTabData
          data={currentTabData}
          setCurrentPanel={setCurrentPanel}
          allHeatMaps={allHeatMaps}
          setAllHeatMaps={setAllHeatMaps}
        />
      ) : (
        <HMapTabNoData title={getTabName(HMapTabs, currentTab)} />
      )}
    </div>
  )
}

export default React.memo(HMapDisplayTabContent)

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    height: '85%',
    padding: '0px 15px',
    overflowY: 'scroll',
    overflowX: 'hidden',
    '&::-webkit-scrollbar': {
      width: 5
    }
  }
}))
